import { http } from './config'

export default {

  getLocalities: () => {
    return http.get('localities?quantity=9999')
  },

  getUserLocalities: () => {
    return http.get('user_localities')
  },

  getUserLocalitiesByUser: (userId) => {
    return http.get('user_localities/by_user/' + userId)
  },

  createUserLocality: (locality_id, user_id) => {
    return http.post('user_localities', {
      "user_locality":
        {
          user_id: user_id,
          locality_id: locality_id
        }
    })
  },

  removeUserLocality: (id) => {
    return http.delete('user_localities/' + id)
  },
}
